export default class ButtonController {
  constructor() {
    this.name = 'button';
  }
}



/** WEBPACK FOOTER **
 ** ./common/button/button.controller.js
 **/